import { Component, OnInit, TemplateRef, ViewChild, EventEmitter, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { GENERAL_MESSAGES } from '@app/shared/data/messages';

@Component({
    selector: 'app-accept-tos-pp-dialog',
    templateUrl: './accept-tos-pp-dialog.component.html',
    styleUrls: ['./accept-tos-pp-dialog.component.scss'],
    standalone: false
})
export class AcceptTosPpDialogComponent implements OnInit {

  @ViewChild('acceptTosPpDialogTemp') acceptTosPpDialogTemp!: TemplateRef<any>;
  @ViewChild('acceptTosPpDeclineDialogTemp') acceptTosPpDeclineDialogTemp!: TemplateRef<any>;
  @Output('sendResponseToParentComp') sendResponseToParentComp = new EventEmitter<any>();
  generalMessages = GENERAL_MESSAGES;
  
  constructor(private readonly _matDialog: MatDialog) { }

  ngOnInit(): void {
    // no initial operations required
  }

  showAcceptTosPpDialog() {
    this._matDialog.closeAll();
    this._matDialog.open(this.acceptTosPpDialogTemp, {
      width: '750px',
      autoFocus: false,
      disableClose: true, 
      panelClass: 'tos-pp-dialog', 
      backdropClass: 'high-dialog-backdrop'
    });
  }

  closeAcceptTosPpDialog(value: boolean = false) {
    this._matDialog.closeAll();
    if (!value) {
      this._matDialog.open(this.acceptTosPpDeclineDialogTemp, {
        width: '485px',
        autoFocus: false,
        disableClose: true, 
        panelClass: 'tos-pp-dialog', 
        backdropClass: 'high-dialog-backdrop'
      });
    } else {
      this.sendResponse(value);
    }
  }

  forceCloseDialog() {
    this._matDialog.closeAll();
    this.sendResponse(false);
  }

  sendResponse(confirmResponse: boolean = false) {
    this.sendResponseToParentComp.emit(confirmResponse);
  }

}
